import React from 'react';

function Footer(props) {
  return(
    <footer>
      <p>Developed By: Erik Savage ©2022</p>
    </footer>
  )
}

export default Footer;